import { render } from "./TransferDetailsContainer.vue?vue&type=template&id=4e0a615e"
import script from "./TransferDetailsContainer.vue?vue&type=script&lang=js"
export * from "./TransferDetailsContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__